import PropTypes from "prop-types";

export default function StepIndicator({ className = "", steps = 0, activeStep, hasLabels = false, stepLabels = [] }) {
  return (
    <div className={`step-indicator ${className}${hasLabels ? " has-labels" : ""}`}>
      {Array.from(Array(steps).keys()).map((step, idx) => (
        <div
          key={idx}
          className={`step${step + 1 < activeStep ? " complete" : ""}${step + 1 === activeStep ? " active" : ""}`}
        >
          {hasLabels && <div className="step-label">{stepLabels[idx] ?? ""}</div>}
        </div>
      ))}
    </div>
  );
}

StepIndicator.prototype = { className: PropTypes.string, steps: PropTypes.number, activeStep: PropTypes.number };
